import m from "../../geodata/es2015/bangladeshLow";
window.am4geodata_bangladeshLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bangladeshLow.js
// module id = null
// module chunks = 